import { css } from "@emotion/react";
import { bpoints } from "../../Utils";

export function syntageCss() {
  return css`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    width: 80%;
    margin: auto;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .ResetPassword{
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    // para el checkbox

    .CheckboxRow{
      margin-top: 1rem;
      display: flex;
      gap: 4%;
    }

    .BlackText{
      color: #000;
      font-family: 'Neue Haas Grotesk Display Pro';
      font-size: calc(0.3rem + 0.8vw);
      font-style: normal;
      font-weight: 500;
    }

    .Paragraph{
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      margin-top: 1rem;
      margin-bottom: 1rem;
    }
    
    .Disclaimer{
      color: #77787B;
      font-family: 'Neue Haas Grotesk Display Pro';
      font-size: calc(0.5rem + 0.5vw);
      font-style: normal;
      font-weight: 500;
      text-align: justify;
      //line-height: 20px; /* 125% */
    }

    .eyePassMobile{
      @media (max-width: ${bpoints.tablet.w}px) {
        top: 1.8rem !important;
      }
    }

    .TopText2{
      width: 80%;
      text-align: center;
    }

    .Button {
      font-size: calc(0.4rem + 0.7vw);
      position: relative;
      cursor: pointer;
      border-radius: 25px;
      display: flex;
      justify-content: center;
      align-items: center;

      padding: 1rem 0;

      flex-basis: 0;
      flex-grow: 1;

      //transition: 300ms;
      @media (max-width: ${bpoints.mobile.w}px) {
        font-size: calc(0.9rem + 0.9vw);
      }
    }

    .Green {
      background-color: #22ec9a;
      color: white;

      border-radius: 17px !important;
      border: unset !important;
      :hover {
        background-color: #2ad690;
      }
    }
    .Blue {
      background-color: #32b8df;
      color: white;

      border-radius: 17px !important;
      border: unset !important;
      :hover {
        background-color: #2da5c8;
      }
    }
    .GradientLeft {
      border: none;
      outline: none;
      background: linear-gradient(to right, #34c6f1, #00ba6e);
      border-radius: 17px;
      z-index: 1;
      //transition: 200ms;

      :hover {
        background: #22ec9a;
      }

      ::before {
        content: "";
        position: absolute;
        left: 2px;
        right: 2px;
        top: 2px;
        bottom: 2px;
        border-radius: 15px;
        background-color: #f5fcfe;
        z-index: -1;
        transition: 200ms;

        @media (max-width: ${bpoints.mobile.w}px) {
          background-color: #e6f9ff;
        }
      }

      ::after {
        content: attr(data);

        color: #00ba6e;
        transition: 200ms;
      }
    }

    .GradientLeft:hover::before {
      background-color: #22ec9a;

      /* @media (max-width: ${bpoints.mobile.w}px){
                background-color: #e6f9ff;
            } */
    }

    .GradientLeft:hover::after {
      color: #fff;
      /* @media (max-width: ${bpoints.mobile.w}px){
                color: #00BA6E;
            } */
    }

    input::placeholder {
      color: #a7a9ac;
    }

    .TextInput {
      background-color: transparent;
      border-radius: 17px;
      border-color: #34c6f1;
      border-width: 1.5px;
      width: 100%;
      padding: 1rem 1.4rem;

      font-family: "Neue Haas Grotesk Display Pro" !important;
      font-style: normal;
      font-weight: 600;
      font-size: calc(0.2rem + 0.7vw);
      color: black;
      //height: 4.5rem;
      //font-size: 23px;
      @media (max-width: ${bpoints.tablet.w}px) {
        font-size: calc(0.8rem + 1vw);
      }

      ::placeholder {
        font-weight: 500;
        color: #a7a9ac;
      }
    }

    .shadowCard {
      margin-top: 1rem;
      height: 1.2rem;
      border-radius: 467px;
      background: radial-gradient(
        50.94% 44.66% at 49.86% 50.14%,
        rgba(0, 0, 0, 0.14) 0%,
        rgba(217, 217, 217, 0) 100%
      );
    }

    .FormContainer {
      width: 60%;

      @media (max-width: ${bpoints.mobile.w}px) {
        margin-top: 1rem;
        width: 90%;
      }

      .FormTitleContainer {
        width: 83.3%;

        @media (max-width: ${bpoints.mobile.w}px) {
          width: 100%;
          margin-top: 4vh;
        }
      }

      .ButtonContainer {
        @media (max-width: ${bpoints.mobile.w}px) {
          width: 100%;
        }
      }
    }

    .Background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
    }

    .InfoContainer {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      .col {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        text-align: center;

        img {
          width: calc(0.9rem + 5vw);
        }

        .FirstImg {
          width: calc(0.2rem + 3vw);
        }
      }

      .BlueLineContainer {
        padding-left: 4%;
        padding-right: 4%;

        .BlueLine {
          width: 100%;
          height: 1px;
          background: #34c6f1;
        }
      }

      .GreenTextContainer {
        color: #1fdd8f;
        font-family: "Neue Haas Grotesk Display Pro";
        font-size: calc(0.5rem + 0.8vw);
        font-style: normal;
        font-weight: 600;
        line-height: 126.923%;

        padding-left: 2%;
        padding-right: 2%;
      }

      .BlackTextContainer {
        color: #000;
        font-family: "Neue Haas Grotesk Display Pro";
        font-size: calc(0.2rem + 0.8vw);
        font-style: normal;
        font-weight: 500;

        padding-left: 4%;
        padding-right: 4%;
      }

      .RequirementsContainer {
        .Left {
          display: flex;
          gap: 10%;
        }

        .Right {
          display: flex;
          flex-direction: column;
        }

        .Column {
          padding-left: 4%;
          padding-right: 4%;

          .Black {
            color: #000;
            font-family: "Neue Haas Grotesk Display Pro";
            font-size: calc(0.2rem + 0.8vw);
            font-style: normal;
            font-weight: 500;
          }

          .BlueTextContainer {
            display: flex;
            flex-direction: column;
            gap: 0.7rem;

            color: #34c6f1;
            font-family: "Neue Haas Grotesk Display Pro";
            font-size: calc(0.2rem + 0.8vw);
            font-style: normal;
            font-weight: 500;
            //line-height:  100%;
          }
        }
      }
    }

    .InputsDiv {
      display: flex;
      flex-direction: column;

      width: 60%;
      .FormTitle {
        color: #000;
        font-family: "Neue Haas Grotesk Display Pro";
        font-style: normal;
        font-weight: 500;
        font-size: calc(0.7rem + 0.5vw);

        margin-top: 1rem;
        margin-bottom: 0.4rem;
      }

      .ResponsiveContainer {
        display: flex;
        gap: 2vw;

        .InputsSection {
          flex-basis: 0;
          flex-grow: 1;
          gap: 1.8rem;

          .PlaceHolder {
            padding: 0 0.5rem;

            font-family: "Neue Haas Grotesk Display Pro" !important;
            font-size: calc(0.2rem + 0.7vw);
            font-style: normal;
            letter-spacing: 0.46px;
            font-weight: 500;

            color: #a7a9ac;
          }
        }
      }
    }

    .DisclaimerSection {
      display: flex;
      flex-direction: column;
      width: 60%;

      margin-top: 2.5rem;

      .Paragraph {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        margin-top: 0.3rem;
        margin-bottom: 1rem;
      }

      .Disclaimer {
        color: #77787b;
        font-family: "Neue Haas Grotesk Display Pro";
        font-size: calc(0.5rem + 0.5vw);
        font-style: normal;
        font-weight: 500;
        text-align: justify;
        //line-height: 20px; /* 125% */
      }

      .CheckboxRow {
        display: flex;
        gap: 2%;

        .BlackText {
          color: #000;
          font-family: "Neue Haas Grotesk Display Pro";
          font-size: calc(0.3rem + 0.8vw);
          font-style: normal;
          font-weight: 500;
        }
      }

      .ButtonWithShadow {
        display: flex;
        flex-direction: column;
        width: fit-content;
        gap: 2rem;

        .Green {
          background-color: #1fdd8f;
          color: white;
          font-size: calc(0.4rem + 0.7vw);
          border-radius: 17px !important;
          border: unset !important;

          width: fit-content;
          padding: 0 6rem;
          :hover {
            background-color: #2ad690;
          }
        }
        .Shadow {
          width: 100%;
          height: 55px;
          border-radius: 467px;
          background: radial-gradient(
            50.94% 44.66% at 49.86% 50.14%,
            rgba(0, 0, 0, 0.14) 0%,
            rgba(217, 217, 217, 0) 100%
          );
        }
      }
    }

    .Container{
        min-height: 60px;
        min-width: 1px;
    }

     .TextContainer {
      display: flex;
      flex-direction: column;
      z-index: 1;

      //margin-top: calc(1rem + 1.5vh);

      text-align: center;

      font-size: calc(10px + 1vw);

      /* background: linear-gradient(90deg, #204B7B 0%, #32B8DF 31.04%, #00BA6E 100%); */
      background: #204b7b;
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;

      @media (max-width: ${bpoints.mobile.w}px) {
        padding: 0 10%;
        font-size: calc(16px + 1vw);

        span {
          display: contents;
        }
      }
    }
       .TopText{
            color: #29588C;
            text-align: center;
            font-family: 'Neue Haas Grotesk Display Pro';
            font-size: calc(0.6rem + 1.4vw);
            font-style: normal;
            font-weight: 600;
            line-height: 105.405%;

            width: 60%;
            margin-top: 3.5rem;
            margin-bottom: 1rem;

            @media (max-width: ${bpoints.mobile.w}px){
                width: 100%;
                padding: 0 8vw;
                font-size: calc(1.4rem + 1.2vw);

            }
        }
  

    .ErrorMessage {
  /* background-color: #f8d7da; */
  color: #d9505e;
  padding: 10px;
  padding-left: 20px;
  /* border: 1px solid #f5c6cb; */
  border-radius: 5px;
  margin: .4rem 0;
  display: inline-block; /* Asegura que ocupe solo el espacio necesario */
}
   
  `;
}
